import angular from 'angular';

var module = angular.module('app.resetPassword', []);

export default module;
